import Navigation from "./Navigation";
// import Footer from "./Footer";
import React from "react";


type WrapperProps = {
    children: React.ReactNode
}


const Wrapper = ({ children }: WrapperProps) => {
    return (
        <div>

            {/* Barre de navigation */}
            <Navigation />


            {/* Contenu de la page */}

            <div className="px-0 md:px-[0%] mt-0 mb-0">
                {children}
            </div>

            {/* Footer */}
            {/* <Footer /> */}

        </div>
    )
}

export default Wrapper;
